import { supabase, clearLocalAuthStorage, handleAuthRefreshError } from '@/lib/supabase';

/** Public portal landing — role selector page. */
export const PORTAL_LOGIN_LANDING = '/login';

export interface PortalLogoutResult {
  ok: boolean;
  error: string | null;
}

/**
 * Sign out from Supabase and clear the local session.
 * Does not clear unrelated app preferences (e.g. language).
 */
export async function signOutFromPortal(): Promise<PortalLogoutResult> {
  try {
    const { error } = await supabase.auth.signOut();

    if (error) {
      console.error('[portalLogout] supabase.auth.signOut failed', {
        message: error.message,
        status: error.status,
      });

      const { error: localError } = await supabase.auth.signOut({ scope: 'local' });
      if (localError) {
        console.error('[portalLogout] local signOut fallback failed', {
          message: localError.message,
          status: localError.status,
        });
        clearLocalAuthStorage();
        return { ok: false, error: error.message };
      }
    }

    clearLocalAuthStorage();
    return { ok: true, error: null };
  } catch (err) {
    const message = err instanceof Error ? err.message : String(err);
    console.error('[portalLogout] unexpected signOut error', message);
    if (await handleAuthRefreshError(err)) {
      return { ok: true, error: null };
    }
    clearLocalAuthStorage();
    return { ok: false, error: message };
  }
}

/** Hard redirect so all in-memory auth hook state is reset. */
export function redirectToPortalLogin(): void {
  const prefix = __BASE_PATH__.replace(/\/$/, '');
  window.location.replace(`${prefix}/login`);
}
